module.exports = __webpack_public_path__ + "media/images/vr/promo-catalogo-section-bg-2-ad5f401658aa8a3f9266064e7c271664.jpg";